import { AutopilotTaskDto, TaskBlockerBlockerType } from '@urbanx/agx.activities.client';
import {
  ExchangeTaskFamily,
  exchangeTaskTypes,
  getExchangeDisplayTask,
  getExchangeTaskFamily,
  getExchangeTaskTitle,
  isExchangeContractDatesTaskType,
  isExchangeInformationTaskType,
  isExchangeTaskType,
} from 'utils/tasks/exchangeTaskIdentity';

export interface ExchangeTaskGroup {
  family: ExchangeTaskFamily;
  informationTask?: AutopilotTaskDto;
  contractDatesTask?: AutopilotTaskDto;
  tasks: AutopilotTaskDto[];
}

export const hasMarkedAsExchangeBlocker = (task?: AutopilotTaskDto) =>
  task?.blockers?.some(
    (blocker) => blocker.blockerType === TaskBlockerBlockerType.MarkedAsExchanged
  ) === true;

export const requiresExchangeEvidence = (group: ExchangeTaskGroup) =>
  group.family !== 'contract' &&
  group.tasks.some((task) => task.isPending || hasMarkedAsExchangeBlocker(task));

export const getExchangeTaskGroups = (tasks: AutopilotTaskDto[]): ExchangeTaskGroup[] => {
  const groups = new Map<string, ExchangeTaskGroup>();

  tasks.forEach((task) => {
    const family = getExchangeTaskFamily(task.category?.taskType);
    if (!family) return;

    const groupKey = `${task.contractId ?? task.campaignId}-${family}`;
    const group =
      groups.get(groupKey) ??
      ({
        family,
        tasks: [],
      } satisfies ExchangeTaskGroup);

    if (isExchangeInformationTaskType(task.category?.taskType)) {
      group.informationTask = task;
    }

    if (isExchangeContractDatesTaskType(task.category?.taskType)) {
      group.contractDatesTask = task;
    }

    group.tasks = [group.informationTask, group.contractDatesTask].filter(
      Boolean
    ) as AutopilotTaskDto[];

    groups.set(groupKey, group);
  });

  return [...groups.values()].filter((group) => group.tasks.length > 0);
};

export {
  exchangeTaskTypes,
  getExchangeDisplayTask,
  getExchangeTaskFamily,
  getExchangeTaskTitle,
  isExchangeTaskType,
};

export type { ExchangeTaskFamily };
